import React from 'react';
import { CssBaseline, ThemeProvider, createTheme, Box, AppBar, Toolbar, Container } from '@mui/material';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/auth/Login';
import Register from './components/auth/Register';
import Dashboard from './components/Dashboard';
import LandingPage from './components/LandingPage';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import TestComponent from './components/TestComponent';
import SimpleTest from './components/SimpleTest';
import HandTrainer from './components/HandTrainer';
import Footer from './components/Footer';
import TournamentList from './components/TournamentList';
import TournamentForm from './components/TournamentForm';
import BankrollChart from './components/BankrollChart';
import About from './components/About';
import UserProfileMenu from './components/UserProfileMenu';
import { Logo } from './components/Logo';
import Settings from './components/Settings';

// Header component with conditional rendering
function Header() {
  const { currentUser } = useAuth();
  
  return currentUser ? (
    <AppBar position="sticky" color="default" elevation={0} sx={{ bgcolor: 'background.paper', borderBottom: '1px solid', borderColor: 'divider' }}>
      <Toolbar>
        <Container maxWidth="lg" sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Logo className="h-8 w-8" />
          </Box>
          <UserProfileMenu />
        </Container>
      </Toolbar>
    </AppBar>
  ) : null;
}

const theme = createTheme({
  typography: {
    fontFamily: '"Roboto", "Arial", sans-serif',
    h3: {
      fontFamily: '"Anton", sans-serif',
    },
    h6: {
      fontFamily: '"Anton", sans-serif',
    }
  },
  palette: {
    mode: 'dark',
    primary: {
      main: '#4e9b71',
    },
    background: {
      default: '#0f172a', // Tailwind slate-900
      paper: '#1e293b',   // Tailwind slate-800
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <AuthProvider>
        <BrowserRouter>
          <CssBaseline />
          <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
            <Header />
            <Box component="main" sx={{ flexGrow: 1 }}>
              <Routes>
                <Route path="/" element={<LandingPage />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/dashboard/*" element={
                  <PrivateRoute>
                    <Dashboard />
                  </PrivateRoute>
                } />
                <Route path="/test" element={<TestComponent />} />
                <Route path="/simple" element={<SimpleTest />} />
                <Route path="/hand-trainer" element={<HandTrainer />} />
                <Route path="/tournaments" element={
                  <PrivateRoute>
                    <TournamentList />
                  </PrivateRoute>
                } />
                <Route path="/add-tournament" element={
                  <PrivateRoute>
                    <TournamentForm />
                  </PrivateRoute>
                } />
                <Route path="/bankroll" element={
                  <PrivateRoute>
                    <BankrollChart />
                  </PrivateRoute>
                } />
                <Route path="/about" element={<About />} />
                <Route path="/settings" element={
                  <PrivateRoute>
                    <Settings />
                  </PrivateRoute>
                } />
                <Route path="*" element={<Navigate to="/" />} />
              </Routes>
            </Box>
            <Footer />
          </Box>
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
